<template>
  <div>
    <header style="margin-top: 70px;" class="section-header">
      <h2 data-title="Museum Interactive 3D Virtual Tour" data-responsive-font="section_title"
        class="section-title ut-flowtyped" :style="{ fontSize: '50px' }">
        <span class="main_title" style="display: flex; justify-content: center; align-items: center;">{{
          $t('museumTitle3') }}</span>
      </h2>

      <div data-delay="0" class="lead mt-3 mb-3 container">
        <p>{{ $t('museumDescription4') }}</p>
      </div>
    </header>

    <div v-if="selectedLanguage" class="mt-5">
      <div class="language-selection-card">
        <button @click="toggleAudio(selectedLanguage)">

          {{ isAudioPaused ? $t('audioControl6') : $t('audioPause7') }} {{ languageNames[selectedLanguage] }}
        </button>
      </div>
    </div>

    <div class="tabs-container">
      <button v-for="(url, index) in imageUrls" :key="index" :class="['tab', { active: currentIndex === index }]"
        @click="changeTab(index)">
        {{ index === 0 ? $t('sign_muzeum') : index === 10 ? $t('address') : $t('room8') }} {{ index === 0 ? '' :
          index === 10 ? '' : index }} </button>
    </div>

    <div v-if="imageUrls.length > 0">
      <div class="tour-content">
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import * as Panolens from 'panolens';

import uz from "@/assets/muzey/darvoza/kirishuz.mp3";
import rus from "@/assets/muzey/darvoza/kirishrus.mp3";
import eng from "@/assets/muzey/darvoza/kirisheng.mp3";

import uz1 from "@/assets/muzey/karidor/karidor.mp3";
import rus1 from "@/assets/muzey/karidor/karidor rus.mp3";
import eng1 from "@/assets/muzey/karidor/karidor eng.mp3";

import uz2 from "@/assets/muzey/memarial xona/memarial.mp3";
import rus2 from "@/assets/muzey/memarial xona/memarial xona rus.mp3";
import eng2 from "@/assets/muzey/memarial xona/memarial eng.mp3";


import uz3 from "@/assets/muzey/yoshlik xonasi/yoshlik XONA.mp3";
import rus3 from "@/assets/muzey/yoshlik xonasi/yoshlik rus.mp3";
import eng3 from "@/assets/muzey/yoshlik xonasi/yoshlik eng.mp3";


import uz4 from "@/assets/muzey/shshmaqom/shashmaqom.mp3";
import rus4 from "@/assets/muzey/shshmaqom/shashmaqom rus.mp3";
import eng4 from "@/assets/muzey/shshmaqom/shashmaqom eng.mp3";


import uz5 from "@/assets/muzey/abadiyat xonasi/adabiyot.mp3";
import rus5 from "@/assets/muzey/abadiyat xonasi/abadiyat rus.mp3";
import eng5 from "@/assets/muzey/abadiyat xonasi/abadiyat eng.mp3";


import uz6 from "@/assets/muzey/sanat xonasi/sanat.mp3";
import rus6 from "@/assets/muzey/sanat xonasi/sanat rus.mp3";
import eng6 from "@/assets/muzey/sanat xonasi/sanat eng.mp3";



import uz7 from "@/assets/muzey/zina/zina.mp3";
import rus7 from "@/assets/muzey/zina/zina rus.mp3";
import eng7 from "@/assets/muzey/zina/zina eng.mp3";


import uz8 from "@/assets/muzey/ko`rgazma zali/korgazma.mp3";
import rus8 from "@/assets/muzey/ko`rgazma zali/ko`rgazma zali rus.mp3";
import eng8 from "@/assets/muzey/ko`rgazma zali/ko'rgazma eng.mp3";


import uz9 from "@/assets/muzey/maruzalar xonasi/maruza.mp3";
import rus9 from "@/assets/muzey/maruzalar xonasi/maruzarus.mp3";
import eng9 from "@/assets/muzey/maruzalar xonasi/maruzaeng.mp3";

import uz10 from "@/assets/muzey/darvoza/kirishuz.mp3";
import rus10 from "@/assets/muzey/darvoza/kirishrus.mp3";
import eng10 from "@/assets/muzey/darvoza/kirisheng.mp3";


const audioFiles = [
  { uz: new Audio(uz), ru: new Audio(rus), en: new Audio(eng) },
  { uz: new Audio(uz1), ru: new Audio(rus1), en: new Audio(eng1) },
  { uz: new Audio(uz2), ru: new Audio(rus2), en: new Audio(eng2) },
  { uz: new Audio(uz3), ru: new Audio(rus3), en: new Audio(eng3) },
  { uz: new Audio(uz7), ru: new Audio(rus7), en: new Audio(eng7) },
  { uz: new Audio(uz4), ru: new Audio(rus4), en: new Audio(eng4) },
  { uz: new Audio(uz5), ru: new Audio(rus5), en: new Audio(eng5) },
  { uz: new Audio(uz8), ru: new Audio(rus8), en: new Audio(eng8) },
  { uz: new Audio(uz6), ru: new Audio(rus6), en: new Audio(eng6) },
  { uz: new Audio(uz9), ru: new Audio(rus9), en: new Audio(eng9) },
  { uz: new Audio(uz10), ru: new Audio(rus10), en: new Audio(eng10) }
];

const languageNames = {
  uz: 'Uzbek',
  ru: 'Russian',
  en: 'English'
};

const imageUrls = [
  require('@/assets/muzey/darvoza/kirish.jpg'),
  require('@/assets/muzey/karidor/karidor.jpg'),
  require('@/assets/muzey/memarial xona/memarial.jpg'),
  require('@/assets/muzey/yoshlik xonasi/yoshlik.jpg'),
  require('@/assets/muzey/zina/zina.jpg'),
  require('@/assets/muzey/shshmaqom/shashmaqom.jpg'),
  require('@/assets/images/img4.jpg'),
  require('@/assets/muzey/ko`rgazma zali/korgazma.jpg'),
  require('@/assets/muzey/sanat xonasi/sanat.jpg'),
  require('@/assets/muzey/maruzalar xonasi/maruza.jpg'),
  require('@/assets/muzey/darvoza/kirish.jpg'),
];

const store = useStore();
const { t, locale } = useI18n();

const selectedLanguage = computed({
  get() {
    return store.getters.getSelectedLanguage;
  },
  set(newLang) {
    store.dispatch("changeLanguage", newLang);
    locale.value = newLang;
    window.location.reload();
  },
});

const currentIndex = ref(0);

const isAudioPaused = computed(() => {
  const currentAudio = audioFiles[currentIndex.value]?.[selectedLanguage.value];
  return currentAudio ? currentAudio.paused || currentAudio.currentTime === 0 : true;
});

const toggleAudio = (lang) => {
  const currentAudio = audioFiles[currentIndex.value]?.[lang];
  if (!currentAudio) return;

  if (currentAudio.paused || currentAudio.currentTime === 0) {
    currentAudio.play();
  } else {
    currentAudio.pause();
  }
};

const changeTab = (index) => {
  stopCurrentAudio();
  currentIndex.value = index;
  playCurrentAudio();
};

const stopCurrentAudio = () => {
  const currentAudio = audioFiles[currentIndex.value]?.[selectedLanguage.value];
  if (currentAudio && !currentAudio.paused) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
  }
};

const playCurrentAudio = () => {
  const currentAudio = audioFiles[currentIndex.value]?.[selectedLanguage.value];
  if (currentAudio) {
    currentAudio.play();
  }
};

const initPanolensViewer = () => {
  const container = document.querySelector('.tour-content');

  if (!container || !imageUrls[currentIndex.value]) {
    console.error('Panorama konteyneri yoki rasm yo‘q.');
    return;
  }

  container.innerHTML = '';

  const panorama = new Panolens.ImagePanorama(imageUrls[currentIndex.value]);

  const viewer = new Panolens.Viewer({
    container: container,
    output: 'console',
    autoHideInfospot: false,
    controlBar: true,
    viewIndicator: true,
    cameraFov: 75,
    devicePixelRatio: window.devicePixelRatio
  });

  viewer.camera.fov = 90;
  viewer.camera.updateProjectionMatrix();

  viewer.add(panorama);

  // Kirganda markazga olib kelish
  panorama.addEventListener('enter', () => {
    viewer.tweenControlCenter(new THREE.Vector3(0, 0, 0), 0);
  });

  // Avvaliga aylantirish va zoomni bloklaymiz
  viewer.disableControl(); // Bu orbitControls.enabled = false qiladi

  // Bir marta bosilganda faollashtiramiz
  let hasActivated = false;
  container.addEventListener('click', () => {
    if (!hasActivated) {
      viewer.enableControl(); // orbitControls.enabled = true
      hasActivated = true;
    }
  });
};





onMounted(() => {
  initPanolensViewer();
});

watch(currentIndex, () => {
  initPanolensViewer();
  playCurrentAudio();
});
</script>

<style scoped>
.language-selection-card {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.language-selection-card button {
  background-color: #29355B;
  color: #EBE9CF;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.language-selection-card button:hover {
  background-color: #5f6779;
  transform: translateY(-2px);
}

.language-selection-card button:active {
  transform: translateY(0);
}

.language-selection-card button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
}

.tabs-container {
  display: flex;
  justify-content: center;
  margin: 20px;
}


/* .tour-content {
  width: 100%;
  height: 80vh;
  max-height: 1000px;
} */

.tab {
  background-color: #29355B;
  color: #EBE9CF;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 5px;
  transition: background-color 0.3s ease;
}

.tab:hover {
  background-color: #4e61a3;
}

.tab.active {
  background-color: #4e61a3;
}

.tour-content {
  width: 80%;
  height: 800px;
  margin: 0 auto;
  position: relative;
}

@media (max-width: 768px) {
  .tabs-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    justify-content: center;
    margin: 20px;
  }

  .tab:last-child {
    grid-column: span 1;
  }
}

@media (max-width: 1150px) {
  .language-selection-card button:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
  }

  .tabs-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    justify-content: center;
    margin: 20px;
  }
}

@media (max-width: 480px) {
  .tour-content {
    height: 600px;
  }

  .main_title {
    font-size: 28px;
    padding-left: 10px;
    font-weight: 600;
  }

  .tabs-container {
    grid-template-columns: 1fr;
  }

  .tab.full-width {
    grid-column: span 1;
  }

  .language-selection-card button:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
  }
}
</style>
